// @flow

import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { change, Field } from 'redux-form';
import { useHistory } from 'react-router';
import { ReduxFormHidden } from '../../../form/hidden';

type OwnProps = {|
  formName: string,
  name: string,
|};

type Props = {|
  ...OwnProps,
  dispatch: Function,
|};

const ReferrerField = ({ dispatch, formName, name }: Props) => {
  const history = useHistory();

  useEffect(() => {
    dispatch(change(
      formName,
      name,
      history.location.pathname,
    ));
  }, [history]);

  return (
    <Field
      component={ReduxFormHidden}
      name={name}
      value={history.location.pathname}
    />
  );
};

// The dummy data set for mapStateToProps is neede, 'cause otherwise readux is messing up all props
export default connect<Props, OwnProps, _, _, _, _>(
  null,
  (dispatch: Function) => ({ dispatch }),
)(ReferrerField);
